<template>
    <div>

        <!--create & delete 버튼-->
        <v-row>
            <v-col cols="5">
                <div>
                    <v-icon class="mdi mdi-magnify search-icon"/>
                    <input 
                        :placeholder="$store.getters.t('스트림명으로 검색')" 
                        v-model="search" 
                        class="search-input">
                </div>
            </v-col>
            
            <v-col class="text-right mb-2">
                <IconButton icon="mdi-refresh" class="mr-2" @click="refresh" small buttonheight="36px"/>

                <TextButton :buttonText="$store.getters.t('생성')" isPrimary class="mr-2" @click="openModal"/>

                <!--라이브 생성 modal-->
                <AppDialog :value="modalOpen" @input="modalOpen = $event" :persistent="true">
                    <template v-slot:title>
                        {{ $store.getters.t('라이브 생성') }}
                    </template>

                    <template v-slot:content>
                        <div class="suport_box">
                            {{ $store.getters.t('원하는') }} <strong>{{ $store.getters.t('라이브 타입') }}</strong> {{ $store.getters.t('을 선택해주세요') }}
                        </div>
                        <v-btn-toggle v-model="live_type" borderless class="mb-2" style="width: 50%;height: 40px;">
                            <v-btn block height="40px" style="border: 1px solid #bbb;" :value="'live'">
                                <span class="hidden-sm-and-down">Live</span>
                            </v-btn>

                            <v-btn block height="40px" style="border: 1px solid #bbb;" :value="'pull'">
                                <span class="hidden-sm-and-down">PULL</span>
                            </v-btn>
                        </v-btn-toggle>
                        <AppInputAlert :message="messageLiveType" :message-type="messageTypeLiveType" class="mb-5"></AppInputAlert>

                        <div class="mt-2">
                            <h4>{{ $store.getters.t('스트리밍 명') }}</h4>
                            <Input :message-type="messageType" :placeholder="$store.getters.t('스트리밍 명을 입력해주세요.')" v-model="stream_name"
                                class="text-right" />
                            <AppInputAlert :message="message" :message-type="messageType" class="mb-5"></AppInputAlert>
                        </div>

                        <div class="mt-4" v-if="live_type === 'pull'">
                            <h4>{{ $store.getters.t('URL') }}</h4>
                            <Input :placeholder="$store.getters.t('URL을 입력해주세요.')" v-model="uri" />
                            <AppInputAlert :message="urlMessage" :message-type="messageType" class="mb-5"></AppInputAlert>
                        </div>

                        <div class="mt-4">
                            <h4>{{ $store.getters.t('보안 스트리밍') }}</h4>
                            <v-radio-group v-model="appType" row>
                                <v-radio label="off" value="basic"></v-radio>
                                <v-radio label="on" value="secure"></v-radio>
                                <AppInputAlert :message="message2" :message-type="messageType2" class="mb-5"></AppInputAlert>
                            </v-radio-group>
                           

                            <div v-if="appType === 'secure'">
                                <h4>{{ $store.getters.t('도메인') }}</h4>
                                <Input :placeholder="$store.getters.t('도메인 입력해주세요.')" v-model="domain" />
                                <AppInputAlert :message="domainMessage" :message-type="messageType" class="mb-5"></AppInputAlert>

                                <h4>{{ $store.getters.t('키') }}</h4>
                                <Input :placeholder="$store.getters.t('키 값을 입력해주세요.')" v-model="privateKey" />
                                <AppInputAlert :message="privateKeyMessage" :message-type="messageType" class="mb-5"></AppInputAlert>

                                <!-- <h4>유효시간 (분 단위)</h4>
                                <Input placeholder="시간을 입력해주세요." v-model="validTime" />
                                <AppInputAlert :message="validTimeMessage" :message-type="messageType" class="mb-5"></AppInputAlert> -->
                            </div>
                        </div>

                    </template>
                    <template v-slot:actions>
                        <TextButtonBlock :buttonText="$store.getters.t('취소')" @click="closeModal" />
                        <TextButtonBlock :buttonText="$store.getters.t('저장')" isPrimary @click="createLive" :loading="createLoading" />
                    </template>
                </AppDialog>
                <!-- <IconButton :loading="deleteLoading"
                icon="mdi-trash-can-outline" :disabled="selected.length === 0 || !allItemsSameType || selected.some(item => item.live_status === 1)
                    || selected.some(item => item.record_status === 1) " @click="deleteLiveItem" class="mr-2" small/> -->
                <IconButton 
                :loading="deleteLoading"
                icon="mdi-trash-can-outline"
                :disabled="selected.length === 0 
                    || !allItemsSameType 
                    || selected.some(item => item.type !== 'pull' && (item.live_status === 1 || item.record_status === 1))"
                @click="deleteLiveItem"
                class="mr-2"
                small
                />
            </v-col>
        </v-row>

        <!--live 관리 data table-->
        <v-data-table :search="search" :headers="headers" :items="lives" :items-per-page="10" :loading="listLoading"
            :footer-props="{ itemsPerPageOptions: [10, 20, 30, -1], itemsPerPageText: 'All' }" class="data-table"
            :disable-sort="true" show-select v-model="selected" :key="lives.id">

            <template v-slot:item.live_status="{ item }">
                <div v-if="item.live_status === 0">
                    <span class="reco_status recording_off">
                        <v-icon x-small class="mdi mdi-square mr-1" color="#999" />
                        {{ $store.getters.t('라이브') }}
                    </span>
                </div>
                <div v-else-if="item.live_status === 1">
                    <span class="reco_status recording_on">
                        <v-icon x-small class="mdi mdi-circle mr-1 blinking" color="#d33333" />
                        {{ $store.getters.t('라이브') }}
                    </span>
                </div>
            </template>

            <template v-slot:item.record_status="{ item }">
                <div v-if="item.record_status === 0">
                    <span class="reco_status recording_off">
                        <v-icon x-small class="mdi mdi-square mr-1" color="#999" />
                        {{ $store.getters.t('녹화') }}
                    </span>
                </div>
                <div v-else-if="item.record_status === 1">
                    <span class="reco_status recording_on">
                        <v-icon x-small class="mdi mdi-circle mr-1 blinking" color="#d33333" />
                        {{ $store.getters.t('녹화') }}
                    </span>
                </div>
            </template>

            <!--live & pull status chip-->
            <template v-slot:item.type="{ item }">
                <template v-if="item.type === 'live'">
                    <v-chip color="#FFF8D1" text-color="#E8B500" small>
                        <v-avatar left><v-icon small>mdi-access-point</v-icon></v-avatar>{{ $store.getters.t('LIVE') }}
                    </v-chip>
                </template>

                <template v-else-if="item.type === 'pull'">
                    <v-chip color="#f0f4ff" text-color="#0040ff" small>
                        <v-avatar left><v-icon small>mdi-record-circle-outline</v-icon></v-avatar>{{ $store.getters.t('PULL') }}
                    </v-chip>
                </template>
            </template>

            <template v-slot:item.appType="{ item }">
                <!-- <v-icon large :color="item.appType === 'secure' ? '#007bff' : '#ccc'">
                    {{ item.appType === 'secure' ? 'mdi mdi-toggle-switch' : 'mdi mdi-toggle-switch-off' }}
                </v-icon> -->

                <!--
                        #007bff
                        primary
                        #0040ff
                -->
                <!-- <v-chip  
                    :color="item.appType === 'secure' ? '#007bff' : '#ccc'"
                    dark
                    small
                    class="ma-1"
                >
                    {{ item.appType === 'secure' ? 'ON' : 'OFF' }}
                </v-chip> -->
                <v-chip small v-if="item.appType === 'secure'" class="success_chip">ON</v-chip>
                <v-chip small v-else disabled>OFF</v-chip>

            </template> 
            
            <template v-slot:item.view="{ item }">
                <v-btn dark elevation="0" small @click="goAction(item)">{{$store.getters.t('View')}}</v-btn>
            </template>
        </v-data-table>

        <AppSnackbar :message="snackbarText" :visible="snackbar" :error="snackbarError" />
    </div>
</template>

<script>
import Input from '@/components/ui/form/FormInput.vue';
import TextButton from '@/components/ui/button/TextButton2.vue';
import TextButtonBlock from '@/components/ui/button/TextButtonBlock.vue';
import IconButton from '@/components/ui/button/IconButton.vue';
import WebRtcStreamApi from "@/api/webrtc/WebRtcStreamApi";
import AppDialog from '@/components/app/AppDialog.vue';
import { mapState } from 'vuex';
import AppSnackbar from "@/components/ui/snackbar/Snackbar.vue";
import AppInputAlert from '@/components/app/AppInputAlert.vue';
import { getDisplayStreamName } from '@/utils/streamName';

export default {
    components: {
        Input,
        TextButton,
        TextButtonBlock,
        IconButton,
        AppDialog,
        AppSnackbar,
        AppInputAlert,
    },
    data() {
        return {
            // headers: [
               
            // ],
            lives: [],
            selected: [],
            stream_name: '',
            modalOpen: false,
            snackbar: false,
            snackbarText: '',
            snackbarError: false,
            snackbarErrorText: '',
            live_type: '',
            message: '',
            messageType: '',
            message2: '',
            messageType2: '',
            messageLiveType: '',
            messageTypeLiveType: '',
            uri: '',
            appType: '',
            requestData: {},
            listLoading: false,
            createLoading: false,
            deleteLoading: false,
            urlMessage: '',
            search: '',
            domain: '',
            privateKey: '',
            // validTime: '',
            domainMessage: '',
            privateKeyMessage: '',
            // validTimeMessage: '',
        }
    },
    created(){
         
    },
    async mounted() {
        
        await this.getLiveList();
    },
    methods: {
        refresh(){
            this.lives = [];
            this.closeModal();
            this.getLiveList();
        },
        async deleteLiveItem() {
            this.deleteLoading = true;

            if (this.selected.length > 0 && !this.selected.some(server =>server.type !== 'pull' && (server.live_status === 1 || server.record_status === 1))) {
            // if (this.selected.length > 0 && !this.selected.some(server => server.live_status === 1 && !this.selected.some(server => server.record_status === 1))) {

                const frontUrl = `${window.location.protocol}//${window.location.host}`;
                const data = {
                    ids: this.selected.map(server => server.id),
                    ip: frontUrl,
                };
                try {
                    const response = await WebRtcStreamApi.deleteApi(data);
                    if (response.status === 1) {
                        this.snackbarText = this.$store.getters.t('삭제 성공');
                        this.snackbarError = false;
                        this.snackbar = true;
                    }
                } catch (error) {
                    console.error('error', error);
                    this.snackbarText = this.$store.getters.t('삭제 실패');
                    this.snackbarError = true;
                    this.snackbar = true;
                }
            } else {
                this.snackbarText = this.$store.getters.t('삭제 실패');
                this.snackbarError = true;
                this.snackbar = true;
            }

            this.deleteLoading = false;
            setTimeout(() => {
                this.snackbar = false;
                this.snackbarText = '';
                this.snackbarError = false;
                this.selected = [];
                this.lives = [];
                this.getLiveList();
            }, 2000);

        },
        async closeModal() {
            this.modalOpen = false;
            this.message = '';
            this.urlMessage = '';
            this.messageType = '';
            this.stream_name = '';
            this.uri = '';
            this.appType = '';
            this.live_type = '';
            this.requestData = {};
            this.selected = [];
        },
        async createLive() {
            const trimmedName = this.stream_name.trim();
            const trimmedType = this.live_type;
            const trimmedAppType = this.appType;

            if(!trimmedType){
                this.messageLiveType = this.$store.getters.t('라이브 타입을 선택해주세요');
                this.messageTypeLiveType = 'warning';

                setTimeout(() => {
                    this.messageLiveType = '';
                    this.messageTypeLiveType = '';
                }, 3000);

                return;
            }

            if (!trimmedName) {
                this.message = this.$store.getters.t('라이브 이름을 넣어주세요');
                this.messageType = 'warning';

                setTimeout(() => {
                    this.message = '';
                    this.messageType = '';
                }, 3000);

                return;
            }

            if(!trimmedAppType){
                this.message2 = this.$store.getters.t('보안 여부를 선택해주세요');
                this.messageType2 = 'warning';

                setTimeout(() => {
                    this.message2 = '';
                    this.messageType2 = '';
                }, 3000);

                return;
            }

            if (this.appType === 'secure') {
                // const trimmedDomain = this.domain.trim();
                const trimmedPrivateKey = this.privateKey.trim();
                // const trimmedValidTime = this.validTime.trim();

                let hasError = false;

                // if (!trimmedDomain) {
                //     this.domainMessage = '도메인을 입력해주세요.';
                //     hasError = true;
                // } else {
                //     this.domainMessage = '';
                // }

                if (!trimmedPrivateKey) {
                    this.privateKeyMessage = this.$store.getters.t('키를 입력해주세요');
                    hasError = true;
                } else {
                    this.privateKeyMessage = '';
                }

                // if (!trimmedValidTime) {
                //     this.validTimeMessage = '시간을 입력해주세요.';
                //     hasError = true;
                // } else if (!/^\d+$/.test(trimmedValidTime)) {
                //     this.validTimeMessage = '숫자만 입력 가능합니다.';
                //     hasError = true;
                // } else {
                //     this.validTimeMessage = '';
                // }

                if (hasError) {
                    this.messageType = 'warning';
                    setTimeout(() => {
                        this.domainMessage = '';
                        this.privateKeyMessage = '';
                        // this.validTimeMessage = '';
                        this.messageType = '';
                    }, 3000);
                    return;
                }
            }


            if(this.live_type == 'pull'){
                const trimmedUrl= this.uri.trim();

                if (!trimmedUrl) {
                    this.urlMessage = this.$store.getters.t('URL을 입력해주세요.');
                    this.messageType = 'warning';

                    setTimeout(() => {
                        this.messageType = '';
                    }, 3000);

                    return;
                }
            }

            this.stream_name = trimmedName;
            this.createLoading = true;
            const frontUrl = `${window.location.protocol}//${window.location.host}`;

            this.requestData = {
                stream_name_by_user: trimmedName,
                stream_name: trimmedName,
                ip: frontUrl,
                type: this.live_type,
                appType: this.appType
            };

            if (this.live_type === 'pull') {
                this.requestData.uri = this.uri;
            }

            if (this.appType === 'secure') {
                this.requestData.domain = this.domain;
                this.requestData.privateKey = this.privateKey;
                // this.requestData.validTime = this.validTime;
            }

            const response = await WebRtcStreamApi.addApi(this.requestData);
   
            if(response.status == 409) {
                this.createLoading = false;
                this.modalOpen = false;
                this.snackbar = true
                this.snackbarText = this.$store.getters.t('스트리밍 명이 중복됩니다');
                this.snackbarError = true;

                setTimeout(() => {
                    this.lives = [];
                    this.getLiveList();
                    this.snackbar = false;
                    this.snackbarError = false;
                    this.stream_name = '';
                    this.uri = '';
                }, 3000);
            } else if(response.status == 500){
                this.createLoading = false;
                this.modalOpen = false;
                this.snackbar = true
                this.snackbarText = this.$store.getters.t('생성 실패하였습니다');
                this.snackbarError = true;

                setTimeout(() => {
                    this.lives = [];
                    this.getLiveList();
                    this.snackbar = false;
                    this.snackbarError = false;
                    this.stream_name = '';
                    this.uri = '';
                }, 3000);
            } else if(response.data.status == 1){
                setTimeout(() => {
                    this.createLoading = false;
                    this.modalOpen = false;
                    this.snackbar = true
                    this.snackbarText = this.$store.getters.t('생성 성공');
                    this.snackbarError = false;

                    setTimeout(() => {
                        this.lives = [];
                        this.getLiveList();
                        this.snackbar = false;
                        this.snackbarError = false;
                        this.stream_name = '';
                        this.uri = '';
                    }, 2000);
                }, 1000);
            }
        },
        async getLiveList() {
            this.listLoading = true;
            try {
                const frontUrl = `${window.location.protocol}//${window.location.host}`;
                const data = {
                    ip: frontUrl,
                };
                const response = await WebRtcStreamApi.listApi(data);

                if(response.status == 1) {
                    this.lives = (response.data || []).map(item => ({
                        ...item,
                        displayStreamName: getDisplayStreamName(item.stream_name_by_user, item.stream_name),
                    }));
                }

            } catch (error) {
                console.error('list error', error);
                return [];
            }
            this.listLoading = false;
        },
        async goAction(item) {
            if (item.type === 'live') {
                this.$router.push({ path: '/webrtc/stream_view/' + item.uuid });
            } else if (item.type === 'pull') {
                this.$router.push({ path: '/webrtc/wowzalivepullstream_view/' + item.uuid });
            }

        },
        openModal() {
            this.live_type = 'live';
            this.appType = 'basic';
            this.requestData = {};
            this.modalOpen = true;
        },
        saveAction() {
            this.modalOpen = false;
        }
    },
    watch: {
        lastSaved(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.getLiveList();
            }
        }
    },
    computed: {
        ...mapState('livestatus', ['lastSaved']),
        allItemsSameType() {
            if (this.selected.length === 0) return true;
            const firstType = this.selected[0].type;
            return this.selected.every(item => item.type === firstType);
        },
        headers(){
            return [
                { text: this.$store.getters.t('스트리밍 명'), value: 'displayStreamName' },
                { text: this.$store.getters.t('라이브 상태'), value: 'live_status' },
                { text: this.$store.getters.t('레코딩 상태'), value: 'record_status' },
                { text: this.$store.getters.t('라이브 타입'), value: 'type' },
                { text: this.$store.getters.t('보안 스트리밍'), value: 'appType' },
                { text: this.$store.getters.t('라이브 관리'), value: 'view' },
            ]
        }
    },
}
</script>

<style scoped>
.alert-active input {
    border: 1px solid red;
}

.application_account_wrap {
    display: flex;
}

.application_account {
    display: flex;
    background: #fff;
    padding: 6px;
    width: 140px;
    border: 1px solid #ddd;
    border-radius: 4px;
    margin-right: 6px;
}

.application_account.pull {
    width: 210px;
}

.application_account_wrap .accoun {
    font-size: 13px;
    color: #999;
}

.application_account_wrap .accoun .txt {
    border-right: 1px solid #ddd;
    padding-right: 8px;
    margin-right: 8px;
    height: 4px;
}

.pull_info {
    border: 1px solid #ccc;
    border-radius: 50%;
    width: 18px;
    height: 18px;
}

.applicationtype {
    padding: 1px 8px 1px 8px;
    border-radius: 2px;
    font-size: 12px;
    margin-right: 8px;
}

.applicationtype.live {
    background: #FFF8D1;
    color: #E8B500;
}

.applicationtype.pull {
    background: #f0f4ff;
    color: #0040ff;
}

.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.spinner {
  width: 50px;
  height: 50px;
  border: 5px solid rgba(255, 255, 255, 0.3);
  border-top: 5px solid white;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.search-input {
    width: 70%;
    height: 36px;
    padding: 8px;
    margin-bottom: 12px;
    border: 1px solid #ccc;
    border-radius: 4px;
    box-sizing: border-box;
    font-size: 14px;
    background: #fff;
    padding-left: 36px;
}

.search-icon {
    position: absolute;
    margin-left: 10px;
    margin-top: 6px;
    color: #aaa;
}

.v-btn-toggle .v-btn.v-btn--active {
  background-color: #cccccc !important;  
  color: #333333 !important;             
  border-color: #cccccc !important;    
}

.v-btn-toggle .v-btn {
  background-color: #ffffff !important;  
  color: #777777 !important;             
  border-color: #dddddd !important;     
  opacity: 1 !important;
}
</style>
